import { POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerFormularioChecklist(obj) {
    try {
        let rows = null;
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/obtener-formulario-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            rows = body;
        }
        return rows;
    } catch (err) {
        console.log("obtenerFormularioChecklist err");
        console.log(err);
        return null;
    }
}

export async function guardarInputFormularioChecklist(obj) {
    try {
        let guardo = { error: false, id: -1 };
        const { code, id } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/guardar-formulario-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('id');
        // console.log(id);
        if (code === SUCCESS) {
            guardo.id = id;
        }
        return guardo;
    } catch (err) {
        console.log("obtenerFormularioChecklist err");
        console.log(err);
        return { error: false, id: -1 };
    }
}

export async function deshabilitarInputFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/deshabilitar-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("deshabilitarInputFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function habilitarInputFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/habilitar-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("habilitarInputFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function intercambiarPosicionFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/intercambiar-posicion-formulario-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("intercambiarPosicionFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function guardarAvanzadoFormularioChecklist(obj) {
    try {
        let guardo = { error: false, id: -1 };
        const { code, id } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/guardar-avanzado-formulario-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('id');
        // console.log(id);
        if (code === SUCCESS) {
            guardo.id = id;
        }
        return guardo;
    } catch (err) {
        console.log("obtenerFormularioChecklist err");
        console.log(err);
        return { error: false, id: -1 };
    }
}

export async function deshabilitarInputAvanzadoFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/deshabilitar-avanzado-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("deshabilitarInputAvanzadoFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function habilitarInputAvanzadoFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/habilitar-avanzado-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("habilitarInputAvanzadoFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function actualizarListaCorreosAvanzadoFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/actualizar-lista-correos-avanzado-formulario-checklist",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("actualizarListaCorreosAvanzadoFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function actualizarListaTelefonosAvanzadoFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/actualizar-lista-telefonos-avanzado-formulario-checklist",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("actualizarListaTelefonosAvanzadoFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function deshabilitarSeleccionMultipleFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/deshabilitar-seleccion-multiple-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("deshabilitarSeleccionMultipleFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function habilitarSeleccionMultipleFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/habilitar-seleccion-multiple-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("habilitarSeleccionMultipleFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function deshabilitarOtroFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/deshabilitar-otro-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("deshabilitarOtroFormularioChecklist err");
        console.log(err);
        return false;
    }
}

export async function habilitarOtroFormularioChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/formulario-checklist/habilitar-otro-formulario-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("habilitarOtroFormularioChecklist err");
        console.log(err);
        return false;
    }
}